module.exports = __webpack_public_path__ + "img/数据大屏背景.a76a3661.png";